import { render, staticRenderFns } from "./TakipAltTipView.vue?vue&type=template&id=9c30c8a2"
import script from "./TakipAltTipView.vue?vue&type=script&lang=ts"
export * from "./TakipAltTipView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports